import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Сменить пароль ")

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";

import UiTextField from "@/components/ui/UiTextField.vue";
import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";

import AppSidebar from "@/components/AppSidebar.vue";
import UiAppbarBack from "@/plugins/ui/components/appbar/UiAppbarBack.vue";
import { computed, reactive, ref } from "vue";

import AccountInfo from "@/features/home/components/AccountInfo.vue";
import { useMessage } from "@/plugins/message";
import router from "@/router";
import { useAsync } from "@/use/useAsync";
import { useAuth } from "@/use/useAuth";
import { useStore } from "@/use/useStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  setup(__props) {

const { currentUser } = useStore();
const { changePassword } = useAuth();
const message = useMessage();

const form = reactive([
  {
    name: "old_password",
    value: "",
    label: "Введите старый пароль",
    type: "password",
    rules: [(v: unknown) => !!(v && String(v).length) || "Заполните это поле"],
  },
  {
    name: "password",
    value: "",
    label: "Введите новый пароль",
    type: "password",
    autocomplete: "new-password",
    rules: [(v: unknown) => !!(v && String(v).length) || "Заполните это поле"],
  },
  {
    name: "password_confirmation",
    value: "",
    label: "Введите новый пароль еще раз",
    type: "password",
    autocomplete: "new-password",
    rules: [
      (v: unknown) => !!(v && String(v).length) || "Заполните это поле",
      (v: unknown) => !!(v === form[1].value) || "Пароли не совпадают",
    ],
  },
]);

const inputs = ref([]);

const valid = computed(() => !inputs.value?.find((input) => input.error));

const onSubmit = useAsync(async () => {
  try {
    await changePassword(currentUser.value!.id, {
      old_password: form[0].value,
      password: form[1].value,
    });
    message({ type: "success", text: "Пароль сменён" });
    router.push("/");
  } catch {
    message({ type: "danger", text: "Ошибка смены пароля" });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, { title: "Смена пароля" }, {
        left: _withCtx(() => [
          _createVNode(UiAppbarBack, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          })
        ]),
        _: 1
      })
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      _createVNode(UiCard, null, {
        default: _withCtx(() => [
          _createVNode(AccountInfo, { style: {"margin-bottom":"16px"} }),
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(onSubmit).execute()), ["prevent"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form, (field) => {
              return (_openBlock(), _createBlock(UiTextField, {
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                key: field.name,
                label: field.label,
                type: field.type,
                autocomplete: field.autocomplete,
                rules: field.rules,
                ref_for: true,
                ref_key: "inputs",
                ref: inputs
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "type", "autocomplete", "rules"]))
            }), 128)),
            _createVNode(UiBtn, {
              loading: _unref(onSubmit).isPending.value,
              disabled: !_unref(valid),
              type: "submit",
              class: "mt-4",
              block: ""
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})